import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckIcon, ArrowRightIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://f13dpf-q0.myshopify.com/cart/47706120126618:1?channel=buy_button';
export function PricingSection() {
  const included = ['Mini curso grabado', '4 mentorías grupales en vivo', '5 bonos exclusivos', 'Acceso a recursos', 'Plantillas y prompts', 'Garantía de 7 días'];
  return <section id="compra" className="bg-gradient-to-b from-gray-900 to-black text-white py-16 md:py-24 px-4" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <div className="text-center mb-12" data-id="element-222">
          <h2 className="text-4xl md:text-5xl font-black mb-8" data-id="element-223">
            Oferta de lanzamiento
          </h2>

          <div className="bg-gray-800 rounded-2xl p-8 mb-8 max-w-3xl mx-auto" data-id="element-224">
            <p className="text-xl md:text-2xl text-gray-300 mb-6" data-id="element-225">
              Todo esto podría valer bastante más por:
            </p>
            <ul className="space-y-3 text-lg text-left max-w-xl mx-auto" data-id="element-226">
              <li className="flex items-center gap-3" data-id="element-227">
                <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-228" />
                <span data-id="element-229">el tiempo que te ahorra</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-230">
                <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-231" />
                <span data-id="element-232">los errores que te evita</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-233">
                <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-234" />
                <span data-id="element-235">y la claridad que te da</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl p-8 md:p-12 shadow-2xl border-2 border-slate-600" data-id="element-236">
          <div className="text-center mb-8" data-id="element-237">
            <p className="text-lg text-slate-400 uppercase tracking-widest font-semibold mb-2" data-id="element-238">
              Precio de lanzamiento en Argentina
            </p>
            <h3 className="text-4xl md:text-5xl font-black mb-2" data-id="element-239">
              Dominando Shopify
            </h3>
            <p className="text-xl text-slate-300 mb-8" data-id="element-240">
              Todo lo que necesitás para armar tu tienda y empezar a vender
            </p>

            <div className="text-gray-900 rounded-2xl p-8 inline-block mb-4 bg-[#26BC3D]" data-id="element-241">
              <p className="text-lg font-semibold mb-2 text-[#FFFFFF]" data-id="element-242">
                por solo
              </p>
              <p className="md:text-7xl font-black text-slate-900 text-[36px]" data-id="element-243">
                ARS 34.990
              </p>
              <p className="text-sm mt-1 font-[700] text-[#FFFFFF]" data-id="element-244">
                ACCESO DE POR VIDA
              </p>
            </div>

            <div className="mb-8" data-id="element-245">
              <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3,
              duration: 0.5
            }} className="inline-flex items-center gap-2 bg-green-500 bg-opacity-15 border border-green-500 border-opacity-40 rounded-full px-6 py-3 mt-4" data-id="element-246">
                <span className="text-green-400 text-lg font-bold" data-id="element-247">💰</span>
                <span className="text-green-300 text-lg font-bold" data-id="element-248">
                  Lo recuperás con tus primeras 2 ventas
                </span>
              </motion.div>
              <p className="text-sm text-slate-400 mt-2" data-id="element-249">
                Es una inversión que se paga sola cuando empezás a vender
              </p>
            </div>
          </div>

          <div className="bg-white bg-opacity-5 border border-slate-600 rounded-xl p-6 mb-8" data-id="element-250">
            <h4 className="text-2xl font-bold mb-6 text-center" data-id="element-251">Incluye:</h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-252">
              {included.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-253">
                  <CheckIcon className="w-6 h-6 text-green-400 flex-shrink-0" data-id="element-254" />
                  <span className="text-lg text-slate-200" data-id="element-255">{item}</span>
                </div>)}
            </div>
          </div>

          <div className="text-center" data-id="element-256">
            <p className="text-xl font-bold mb-6 text-slate-300" data-id="element-257">
              💳 En hasta 3 cuotas
            </p>
            <motion.div animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-258">
              <CTAButton text="QUIERO EMPEZAR AHORA →" href={CHECKOUT_URL} size="large" className="!bg-green-500 hover:!bg-green-400 !text-white font-black text-2xl w-full md:w-auto shadow-[0_0_30px_rgba(34,197,94,0.4)] hover:shadow-[0_0_40px_rgba(34,197,94,0.6)]" data-id="element-259" />
            </motion.div>
            <div className="mt-6 flex flex-col items-center gap-3" data-id="element-260">
              <img src="https://cdn.magicpatterns.com/uploads/atARmzfGK6cg37j9MinZG9/logo_mercado_pago.png" alt="Mercado Pago" className="h-10 object-contain" data-id="element-261" />
              <p className="text-sm text-slate-400 font-semibold" data-id="element-262">
                🔒 Compra verificada y protegida por MercadoPago
              </p>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-blue-900 bg-opacity-50 border-2 border-blue-400 rounded-2xl p-8 text-center" data-id="element-263">
          <h4 className="text-2xl font-bold mb-4" data-id="element-264">
            ✓ Garantía de 7 días sin vueltas
          </h4>
          <p className="text-lg text-gray-300" data-id="element-265">
            Queremos que entres con tranquilidad. Por eso tenés una garantía
            simple de 7 días. Si accedés al programa y sentís que no era para
            vos, podés pedir la devolución dentro de ese plazo. Sin vueltas.
          </p>
        </div>
      </div>
    </section>;
}